import { useStore } from '@nanostores/react';
import { useEffect } from 'react';

import { AssetLibraryModal } from './browser';
import { $assetLibraryModal } from './browser/store';
import { installAssetBridge, uninstallAssetBridge } from './bridge';
import { AssetOptimizerModal } from './optimizer/asset-optimizer-modal';
import { UploadAssetModal } from './upload';

export function AssetLibrary() {
  const { isOpen } = useStore($assetLibraryModal);

  // Install the window bridge so external code can call selectAsset()
  useEffect(() => {
    installAssetBridge();
    return () => uninstallAssetBridge();
  }, []);

  // Emit open/close events for the canvas pointer-events workaround
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('cio-asset-library', { detail: { isOpen } }));
  }, [isOpen]);

  return (
    <>
      <AssetLibraryModal />
      <UploadAssetModal />
      <AssetOptimizerModal />
    </>
  );
}
